// export enum AmbulatoryDoctorDocument {
//   IDENTITY_CARD = 'IDENTITY_CARD',
//   HEALTH_CARD = 'HEALTH_CARD',
//   MEDICAL_ORDER = 'MEDICAL_ORDER',
//   LABORATORY_EXAMS = 'LABORATORY_EXAMS',
//   EXAM_REPORT = 'EXAM_REPORT',
//   OTHERS = 'OTHERS'
// }

// export enum AmbulatoryDoctorDocumentLocation {
//   IDENTITY_CARD = 'Carteira de identidade',
//   HEALTH_CARD = 'Carteira do convênio',
//   MEDICAL_ORDER = 'Pedido médico',
//   LABORATORY_EXAMS = 'Exames laboratoriais',
//   EXAM_REPORT = 'Laudos de exames',
//   OTHERS = 'Outros'
// }

// export enum AmbulatoryDoctorDocument {
//   IDENTITY_CARD = 'IDENTITY_CARD',
//   HEALTH_CARD = 'HEALTH_CARD',
//   MEDICAL_ORDER = 'MEDICAL_ORDER',
//   LABORATORY_EXAMS = 'LABORATORY_EXAMS',
//   EXAM_REPORT = 'EXAM_REPORT',
//   OTHERS = 'OTHERS'
// }

export enum AmbulatoryDoctorDocument {
  'Carteira de identidade' = 'Carteira de identidade',
  'Carteira do convênio' = 'Carteira do convênio',
  'Pedido médico' = 'Pedido médico',
  // 'Exames laboratoriais' = 'Exames laboratoriais',
  'Laudo dos exames' = 'Laudo dos exames',
  'Outros' = 'Outros',
  'Guia autorizada' = 'Guia autorizada'
}
